module.exports = __webpack_public_path__ + "assets/img/zre1.28ea3b9c.png";